import NoteAltIcon from '@mui/icons-material/NoteAltOutlined';

const MaterialNoteAltIcon = (props) => {
  return <NoteAltIcon htmlColor="#1F1f1f" {...props} />;
};

export default MaterialNoteAltIcon;
